import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function topScrollEvent() {
  if (document.querySelector(".is-top")) {
    const wrap = document.querySelector(".wrap");

    function removeClass() {
      wrap.classList.remove("is-blue");
      wrap.classList.remove("is-white");
      wrap.classList.remove("is-yellow");
      wrap.classList.remove("is-green");
    }

    ScrollTrigger.create({
      trigger: ".is-top .section-hero",
      start: "top center",
      end: "bottom center",
      onEnterBack: () => {
        removeClass();
        wrap.classList.add("is-white");
      },
    });

    ScrollTrigger.create({
      trigger: ".is-top .section-news",
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        removeClass();
        wrap.classList.add("is-blue");
      },
      onEnterBack: () => {
        removeClass();
        wrap.classList.add("is-blue");
      },
    });

    ScrollTrigger.create({
      trigger: ".is-top .section-enjoy",
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        removeClass();
        wrap.classList.add("is-yellow");
      },
      onEnterBack: () => {
        removeClass();
        wrap.classList.add("is-yellow");
      },
    });

    // ScrollTrigger.create({
    //   trigger: ".is-top .section-xxx",
    //   start: "top center",
    //   end: "bottom center",
    //   onEnter: () => {
    //     removeClass();
    //     wrap.classList.add("is-green");
    //   },
    //   onEnterBack: () => {
    //     removeClass();
    //     wrap.classList.add("is-green");
    //   },
    // });
  }
}
